// extracted by mini-css-extract-plugin
export default {"sectionImage":"Home_sectionImage__FxLTQ","logoOverlay":"Home_logoOverlay__8Ozlj","logo":"Home_logo__tseYk"};